import { ERightType } from '@/apis/commerce';

/**
 * 按创单时冻结的 right_type 解析支付成功 toast。
 * RT=3 / RT=4 用专用文案；其余沿用现有成功 toast。
 */
export function resolvePaySuccessToastMessage(t: (key: string) => string, rightType?: number): string {
    if (rightType === ERightType.FullBook) {
        return t('pay_fullbook_success');
    }
    if (rightType === ERightType.OneTimeMembership) {
        return t('pay_onetime_membership_success');
    }
    return t('pay_store_success');
}
